<script setup>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import EditDialog from '@/components/EditDialog.vue'
  import DataTable from '@/components/DataTable.vue'
  import { ref, inject, onMounted, computed } from 'vue'
  import { useRoute, useRouter, RouterLink, RouterView } from 'vue-router'
  import { testPosts } from '@/testdata/testdata'
  import { useDialogStore } from '@/stores/dialogStore'
  import { useInfoStore } from '@/stores/infoStore'
  import { useUserStore } from '@/stores/userStore'

  const router = useRouter()
  const query = useRoute().query

  const dialogStore = useDialogStore()
  const infoStore = useInfoStore()
  const userStore = useUserStore()

  const breadcrumbs = [{ name: 'ダッシュボード', url: 'dashboard' }, { name: 'お知らせ' }]

  // 変数 /////////////////////
  const showPopupEdit = ref(query.action === 'new' ? true : false)
  const isEdit = ref(false)

  const searchText = ref('')
  const sortKey = ref('')
  const sortDesc = ref(false)
  const length = ref('')

  // methods ////////////////////////////////
  // ページデータ取得API呼び出し
  const getPageData = async () => {
    await infoStore.getInfos()
    await infoStore.initTableList()
  }

  // お知らせ編集ダイアログ表示
  const openEditPost = item => {
    isEdit.value = item ? true : false
    infoStore.setFormData(item?.id)
    showPopupEdit.value = true
  }

  // 保存ボタン押下
  const onSave = async () => {
    const message = await infoStore.saveInfo()
    if (message) {
      await dialogStore.showMessageDialog('保存', message)
      showPopupEdit.value = false
    }
  }

  // コピーボタン押下
  const onCopy = () => {
    infoStore.onCopy()
    isEdit.value = false
  }

  // 削除ボタン押下
  const onDelete = async () => {
    const message = await infoStore.deleteInfo()
    if (message) {
      await dialogStore.showMessageDialog('削除', message)
      showPopupEdit.value = false
    }
  }

  onMounted(async () => {
    await getPageData()
    if (query.action === 'new') {
      openEditPost()
    }
  })
</script>

<template>
  <Header />
  <main class="app-main">
    <div class="main-header">
      <h2>お知らせ</h2>
      <button type="button" class="new" @click="openEditPost()">新規登録</button>
      <div class="filters">
        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input type="search" v-model="searchText" placeholder="検索" />
        </div>
        <div class="search-result">
          {{ length }}
        </div>
      </div>
    </div>
    <div class="main-body">
      <div class="table-content">
        <DataTable :table-list="infoStore.tableList" :data-list="infoStore.infos" :search-text="searchText" :sort-key="sortKey" :sort-desc="sortDesc" @select="openEditPost" @length="length = $event"></DataTable>
      </div>
    </div>
  </main>
  <Footer :breadcrumbs="breadcrumbs" />
  <EditDialog v-model:visible="showPopupEdit" :show-delete-button="isEdit" :show-copy-button="isEdit" :save-button-text="isEdit ? '保存' : '登録'" @save="onSave" @copy="onCopy" @delete="onDelete">
    <template v-slot:title>{{ isEdit ? '編集' : '新規登録' }}</template>
    <template v-slot:content>
      <div class="dialog-edit">
        <dl>
          <dt>表示</dt>
          <dd>
            <div style="display: flex; gap: 10px; align-items: center">
              <input type="datetime-local" v-model="infoStore.formData.startAt" />
              から
              <input type="datetime-local" v-model="infoStore.formData.endAt" />
              まで
            </div>
          </dd>
          <dt>タイトル</dt>
          <dd>
            <input type="text" v-model="infoStore.formData.title" />
          </dd>
          <dt>内容</dt>
          <dd>
            <textarea v-model="infoStore.formData.text"></textarea>
          </dd>
          <dt v-if="isEdit">最終更新者</dt>
          <dd v-if="isEdit">{{ infoStore.formData.lastEditor }}</dd>
        </dl>
      </div>
    </template>
  </EditDialog>
</template>

<style lang="less" scoped></style>
